import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import classNames from 'classnames';

import { Typography } from '@material-ui/core';

import { Input } from 'components';

import { currencyFormatter } from 'utils/prices/formatter';
import { getFormByCurrentLanguage } from 'utils/form-localization/formLocalization';

import useStyles from './styles';

const Currency = ({ isWidget, item, currency }) => {
  const classes = useStyles();

  return (
    <>
      {isWidget ? (
        <Typography variant="h3" className={classes.currencyWrapper}>
          <span className={classes.currency}>{currency}</span>{' '}
          {currencyFormatter(item[currency])}
        </Typography>
      ) : (
        <Typography variant="h3">
          {currency}{' '}
          <span className={classes.addOnsPrice}>
            {currencyFormatter(item[currency])}
          </span>
        </Typography>
      )}
    </>
  );
};

const AddOnsList = ({
  fields,
  title,
  currency,
  titleClass,
  addOnItemClass,
  wrapperClass,
  addOnDescClass,
  addOnTitle,
  isWidget
}) => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  const selectedLanguage = i18n.language;

  if (!fields.length) return null;

  return (
    <div className={classNames(classes.sectionIndent, wrapperClass)}>
      {title && (
        <Typography variant="h2" className={classes.inputIndent}>
          {t(title)}
        </Typography>
      )}
      <div>
        {fields.map((field, index) => {
          const item = fields.get(index);
          const form = getFormByCurrentLanguage(
            selectedLanguage,
            item,
            item['Norwegian']
          );
          return (
            <div
              key={item.id}
              // style={{ display: form.description ? 'flex' : 'block' }}
              className={classNames(classes.addOnsItem, addOnItemClass)}
            >
              {item.coverPhoto.image && (
                <div
                  className={classes.photo}
                  style={{
                    backgroundImage: `url(${item.coverPhoto.image})`
                  }}
                />
              )}
              <div style={{ width: '100%' }}>
                {form.description && (
                  <div className={classes.itemTitleWrapper}>
                    <Typography
                      variant="body1"
                      className={classNames(classes.addOnsTitle, titleClass)}
                    >
                      {form.title}
                    </Typography>
                    <div className={classes.titleCurrency}>
                      <Currency
                        isWidget={isWidget}
                        currency={currency}
                        item={item}
                      />
                    </div>
                  </div>
                )}
                <div className={classes.addOnsInfo}>
                  <Typography
                    variant={form.description ? 'body1' : 'h3'}
                    className={classNames(
                      classes.addOnsDescription,
                      addOnDescClass,
                      addOnTitle
                    )}
                  >
                    {form.description ? form.description : form.title}
                  </Typography>
                  <div className={classes.currencyInputWrapper}>
                    <div
                      className={classNames(classes.descriptionCurrency, {
                        [classes.mobileDescriptionCurrency]: !form.description
                      })}
                    >
                      <Currency
                        isWidget={isWidget}
                        currency={currency}
                        item={item}
                      />
                    </div>
                    <Field
                      name={`${field}.value`}
                      isOnlyNumber={true}
                      maxLength={9}
                      className={classes.addOnsInput}
                      component={Input}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AddOnsList;
